import { gql } from "@apollo/client";

export default gql`
  query getProfileQuery($userId: Int!, $currentUserId: Int!, $now: DateTime!) {
    user(userId: $userId) {
      id
      name
      firstName
      email
      status
      avatar
      isInCurrentUserReportingTree
      upcomingOneonone: meetings(
        isFormalOneonone: true
        participants: [$currentUserId]
        startDatetime_Gte: $now
        first: 1
      ) {
        edges {
          node {
            id
          }
        }
      }
      managersList {
        id
        name
        avatar
      }
      primaryManager {
        id
        name
        firstName
        email
      }
    }
  }
`;
